/** Keep in sync with peppar-site/lib/legal.ts and LegalConsentServiceImpl.DOCUMENT_VERSION. */
export const LEGAL = {
  brandName: 'Peppar',
  entityName: 'Peppar Enterprises',
  udyam: 'UDYAM-KR-03-0746307',
  documentVersion: '2026-08-28',
  lastUpdatedLabel: '28 August 2026',
  jurisdictionCity: 'Bengaluru, Karnataka',
  hasRegisteredOffice: false,
} as const;
